var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M452.285,228.103l-196.445,1.499l0,0l-196.445,1.499l0.473,62.004l0,0 c0.005,0.664,0.034,1.321,0.048,1.983c0.014,0.6,0.022,1.202,0.043,1.801c1.731,55.785,32.134,104.24,76.899,131.244l0.227-0.001 c24.278,14.65,52.757,22.988,83.166,22.756l37.274-0.285l0,0l37.274-0.285c30.408-0.232,58.757-9.004,82.809-24.023l0.227-0.001 c44.348-27.684,74.009-76.597,74.888-132.403c0.012-0.599,0.011-1.201,0.016-1.801c0.004-0.662,0.023-1.32,0.017-1.984l0,0 L452.285,228.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656890"
    },
    d: "M348.842,406.978c-3.361,5.918-6.316,12.094-8.843,18.485c-6.763,17.1-10.424,35.755-10.276,55.273 l0.16,20.967c0.479-0.133,0.958-0.264,1.434-0.4c3.636-1.03,7.242-2.13,10.816-3.302c6.224-2.039,12.341-4.311,18.366-6.759 c3.677-1.494,7.329-3.04,10.926-4.685c2.478-1.133,4.94-2.295,7.379-3.497C377.782,453.969,366.653,427.486,348.842,406.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAE3DE"
    },
    d: "M256.001,419.244l-101.529,0.3l-0.451-0.3c-12.634,18.874-20.19,41.42-20.673,65.689 c11.867,5.625,24.193,10.432,36.895,14.38c3.591,1.116,7.213,2.161,10.865,3.136c0.479,0.128,0.96,0.253,1.44,0.378 c23.448,6.128,48.069,9.334,73.455,9.166l36.835-92.748h-36.837V419.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDCDD4"
    },
    d: "M162.148,408.402c-17.495,20.778-28.219,47.427-28.798,76.531 c11.867,5.625,24.193,10.432,36.895,14.38c3.591,1.116,7.213,2.161,10.865,3.136c0.479,0.128,0.96,0.253,1.44,0.378l-0.16-20.967 C182.184,455.048,174.828,429.965,162.148,408.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83A1C1"
    },
    d: "M348.842,406.978c-6.493-7.476-13.871-14.158-21.973-19.882 c-20.253-14.309-45.014-22.64-71.703-22.436s-51.32,8.911-71.352,23.527c-8.014,5.848-15.29,12.642-21.667,20.215 c-2.906,3.453-5.607,7.081-8.124,10.842l0.451,0.3c2.429,1.742,4.889,3.422,7.374,5.046c3.659,2.391,7.379,4.646,11.154,6.763 c3.114,1.747,6.261,3.407,9.446,4.957c6.414,3.12,12.907,5.809,19.462,8.094c14.908,5.195,30.144,8.224,45.552,9.04 c2.842,0.151,5.69,0.236,8.542,0.236c0.001,0,0.002,0,0.004,0v58.313c0.096,0,0.19,0.001,0.286,0 c25.488-0.194,50.154-3.779,73.593-10.289c0.479-0.133,0.958-0.264,1.434-0.4c3.636-1.03,7.242-2.13,10.816-3.302 c6.224-2.039,12.341-4.31,18.366-6.759c3.677-1.494,7.329-3.04,10.926-4.685c2.478-1.133,4.94-2.295,7.379-3.497 C377.782,453.969,366.653,427.486,348.842,406.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0B7CB"
    },
    d: "M287.185,443.003c-4.087-0.037-8.041,0.497-11.788,1.526c-12.847,3.526-26.338,3.629-39.237,0.3 c-3.763-0.971-7.724-1.445-11.81-1.347c-23.246,0.561-42.091,20.92-41.914,44.172l0.002,0.345l0.113,14.828 c23.536,6.151,48.253,9.36,73.741,9.166c25.488-0.194,50.154-3.779,73.593-10.289l-0.113-14.828l-0.002-0.345 C329.59,463.278,310.437,443.208,287.185,443.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#668BB7"
    },
    cx: 293.142,
    cy: 459.818,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#668BB7"
    },
    cx: 292.835,
    cy: 496.653,
    r: 9.209
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M446.312,174.351c-9.007,0-17.503,2.17-25.017,5.993c-18.361-69.449-73.182-132.281-140.659-144.885 L194.53,411.468c19.089,9.286,39.81,14.585,61.471,14.585c78.525,0,144.749-69.455,165.297-147.191 c7.512,3.822,16.007,5.992,25.014,5.992c30.515,0,55.252-24.737,55.252-55.252S476.827,174.351,446.312,174.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1B872"
    },
    d: "M280.637,35.459c-8.047-1.503-16.27-2.307-24.636-2.307c-78.525,0-144.749,69.455-165.297,147.191 c-7.513-3.823-16.007-5.992-25.014-5.992c-30.515,0-55.252,24.737-55.252,55.252s24.737,55.252,55.252,55.252 c9.012,0,17.511-2.171,25.027-5.998c14.881,56.289,53.702,108.235,103.814,132.612c8.047,1.503,16.27,2.307,24.636,2.307 c94.935,0,171.894-101.516,171.894-196.451C391.061,144.05,345.209,66.871,280.637,35.459z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C98A2E"
    },
    cx: 446.312,
    cy: 229.602,
    r: 18.417
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5A150"
    },
    cx: 65.689,
    cy: 229.602,
    r: 18.417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M394.225,177.511c-21.715,21.715-49.703,33.674-78.81,33.674h-4.159 c-56.336,0-104.583-40.147-114.722-95.46l-5.184-28.285l-23.524,16.54c-29.039,20.416-50.043,50.094-59.575,84.001 c-1.39,0.566-2.69,1.304-3.886,2.176c4.367,4.283,8.025,9.284,10.783,14.811c6.074,12.177,23.872,10.676,27.377-2.473 c0.053-0.198,0.103-0.395,0.152-0.595c4.534-18.622,13.588-35.707,26.214-49.867c22.972,57.059,78.753,95.987,142.365,95.987h4.159 c26.8,0,52.791-7.477,75.739-21.484c0.747-13.634,6.451-25.932,15.322-35.167l-7.334-18.352 C397.447,174.43,395.805,175.929,394.225,177.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M167.601,263.367h-12.278c-5.087,0-9.209-4.123-9.209-9.209s4.122-9.209,9.209-9.209h12.278 c5.087,0,9.209,4.123,9.209,9.209S172.688,263.367,167.601,263.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M356.685,263.367h-12.278c-5.087,0-9.209-4.123-9.209-9.209s4.122-9.209,9.209-9.209h12.278 c5.087,0,9.209,4.123,9.209,9.209S361.772,263.367,356.685,263.367z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M274.422,238.811h-36.835c-5.086,0-9.209,4.123-9.209,9.209c0,15.234,12.392,27.626,27.626,27.626 c15.234,0,27.626-12.392,27.626-27.626C283.63,242.934,279.507,238.811,274.422,238.811z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M335.813,211.185h-36.835c-5.086,0-9.209,4.123-9.209,9.209s4.123,9.209,9.209,9.209 c0,10.171,8.246,18.417,18.417,18.417s18.417-8.246,18.417-18.417c5.086,0,9.209-4.123,9.209-9.209 S340.898,211.185,335.813,211.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M213.031,211.185h-36.835c-5.086,0-9.209,4.123-9.209,9.209s4.123,9.209,9.209,9.209 c0,10.171,8.246,18.417,18.417,18.417c10.171,0,18.417-8.246,18.417-18.417c5.086,0,9.209-4.123,9.209-9.209 S218.116,211.185,213.031,211.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M177.544,186.285c-3.882,0-7.492-2.474-8.756-6.366c-1.572-4.836,1.076-10.031,5.912-11.603 c13.044-4.238,26.818-4.238,39.832-0.001c4.836,1.574,7.48,6.771,5.906,11.607c-1.573,4.836-6.769,7.482-11.607,5.906 c-9.288-3.024-19.122-3.022-28.44,0.005C179.446,186.139,178.487,186.285,177.544,186.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M74.064,118.064c-5.687,12.608-8.371,26.365-8.371,40.198v16.089 c21.692,0,40.453,12.507,49.495,30.695c4.543,0,8.519-3.09,9.593-7.504c7.853-32.25,27.281-59.965,53.638-78.497l0.177-9.845 c0.421-23.37-19.024-42.217-42.37-41.068l0,0C101.653,76.842,83.482,97.183,74.064,118.064z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB5034"
    },
    d: "M136.228,68.132c-34.574,8.71-52.745,29.05-62.163,49.929c-3.958,8.775-6.458,18.107-7.615,27.632 c7.745,0.507,16.869,2.093,27.157,5.809l0.166,0.06c9.082,3.291,19.235-0.19,24.37-8.372c6.272-9.994,13.63-19.301,21.956-27.749 c7.103-7.207,10.951-17.008,10.968-27.126l0.036-20.915L136.228,68.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M426.18,122.584C402.77,97,361.877,55.979,319.335,30.474C253.896-8.761,176.669-8.023,146.594,20.77 c-30.075,28.794-10.366,47.361-10.366,47.361l42.191,50.913c11.528,62.894,66.614,110.559,132.838,110.559h4.157 c34.648,0,67.332-14.568,91.832-39.068c9.999-9.999,23.812-16.184,39.07-16.184C446.316,155.182,439.12,136.727,426.18,122.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB5034"
    },
    d: "M207.995,123.758c0.009,0.026,0.016,0.052,0.025,0.075c14.933,45.681,74.293,60.776,109.357,25.292 l0.339-0.343c25.486-25.792,62.478-36.605,97.842-28.602l10.623,2.404C402.772,97,361.878,55.979,319.336,30.474 C253.897-8.761,176.67-8.023,146.595,20.77c-2.737,2.62-5.056,5.154-7.021,7.598l49.412,60.04 C197.568,98.836,203.917,110.885,207.995,123.758z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.125b83fa3dcd6ebd9d441a2f6b7af771.svg";
export { ForwardRef as ReactComponent };